import { useState, useEffect, useRef } from "react";
import searchIcon from "../../../../assets/admin/search.svg";

const OrderSearchBar = (props) => {

    const {
        getWineData,
        searchCodice,
        setSearchCodice,
        searchNome,
        setSearchNome,
        setAllwinesData,
        setPage
    } = props


    const [debouncedSearch, setDebouncedSearch] = useState({ key: "", value: "" });
    const searchRef = useRef({ key: "", value: "" });

    useEffect(() => {
        const handler = setTimeout(() => {
            if (debouncedSearch.value === "") {
                setAllwinesData([]);
                getWineData();
                setPage(1);
                return;
            }

            getWineData(debouncedSearch.key, debouncedSearch.value);
        }, 300);

        return () => clearTimeout(handler);
    }, [debouncedSearch]);

    const handleSearch = (key, value) => {
        setPage(1);
        if (key === "name") {
            setSearchNome(value);
            setSearchCodice("");
        } else {
            setSearchCodice(value);
            setSearchNome("");
        }

        searchRef.current = { key, value };
        setDebouncedSearch({ key, value });
    };


    return (
        <>
            <div className="grid grid-col-1 lg:grid-cols-2 gap-3 2xl:gap-7 2xl:gap-10 ">

                <div className="flex flex-col w-full gap-3">
                    <div className="relative group xl:w-[100%]">
                        <div
                            className="inline-flex h-full justify-between items-center w-full px-6 pl-8 py-2 outline-none text-[#8F8F8F] border border-[#D9D9D9] rounded-full shadow-sm"
                        >
                            {/* <input
                                type="text"
                                placeholder="Codice"
                                className="text-[#8F8F8F] outline-none pl-4 poppins-medium relative w-full h-full"
                                value={searchCodice}
                                onChange={(e) => {
                                    setSearchCodice(e.target.value);
                                    getWineData("code", e.target.value);
                                }}
                            /> */}

                            <input
                                type="text"
                                placeholder="Codice"
                                className="outline-none pl-4 relative w-full h-full"
                                value={searchCodice}
                                onChange={(e) => handleSearch("code", e.target.value)}
                            />

                            <img
                                src={searchIcon}
                                className="absolute left-4 top-0 bottom-0 my-auto h-4 w-4"
                                alt="Search"
                            />
                        </div>
                    </div>
                </div>

                <div className="flex flex-col w-full gap-3">
                    <div className="relative group  xl:w-[100%]">
                        <div
                            className="inline-flex h-full justify-between items-center w-full px-6 pl-8 py-2 outline-none text-[#8F8F8F] border border-[#D9D9D9] rounded-full shadow-sm"
                        >
                            {/* <input
                                type="text"
                                placeholder="Nome"
                                className="text-[#8F8F8F] outline-none pl-4 poppins-medium relative w-full h-full"
                                value={searchNome}
                                onChange={(e) => {
                                    setSearchNome(e.target.value);
                                    getWineData("name", e.target.value);
                                }}
                            /> */}

                            <input
                                type="text"
                                placeholder="Nome"
                                className="outline-none pl-4 relative w-full h-full"
                                value={searchNome}
                                onChange={(e) => handleSearch("name", e.target.value)}
                            />
                            <img
                                src={searchIcon}
                                className="absolute left-4 top-0 bottom-0 my-auto h-4 w-4"
                                alt="Search"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default OrderSearchBar




